import {
  AdmissionCriteriaContent,
  CohortContent,
  CricosCodeContent,
  TargetArticulationContainer,
  TargetArticulationsContainer,
  TargetCourseContent,
  ViewCourseContent,
} from 'components/credits/credit-items/TargetArticulationsSection/components';

import { Articulation } from 'types/articulation';
import { CreditPointsSection } from 'components/credits/credit-items/CreditPointsSection';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import InstitutionCaption from 'components/common/InstitutionCaption';
import { Spin } from 'antd';
import { getTotalCreditPoints } from 'utils/articulation';
import useIsMobile from 'hooks/use-is-mobile';
import useTranslation from 'hooks/use-translation';

type Props = {
  articulations: Articulation[];
};

export function TargetArticulationsSection(props: Props): JSX.Element {
  const { articulations } = props;
  const translation = useTranslation();
  const isMobile = useIsMobile();

  if (!translation) {
    return <Spin />;
  }

  if (isMobile) {
    const articulation = articulations[0];
    return (
      <TargetArticulationsContainer className='target-articulations-list'>
        <FlexContainer gap={8}>
          <TargetCourseContent course={articulation.course} />
          <CricosCodeContent course={articulation.course} />
          <InstitutionCaption />
          <CohortContent articulation={articulation} />
          <AdmissionCriteriaContent articulation={articulation} />
          <ViewCourseContent course={articulation.course} />
        </FlexContainer>
        <CreditPointsSection
          courseName={articulation.course.name}
          creditItemID={articulation.ID}
          creditType={CreditType.ARTICULATION}
          creditPoints={getTotalCreditPoints(articulation)}
        />
      </TargetArticulationsContainer>
    );
  }

  return (
    <TargetArticulationsContainer className='target-articulations-list'>
      {articulations.map((articulation) => (
        <TargetArticulationContainer className='target-articulation' key={articulation.ID}>
          <FlexContainer gap={8}>
            <FlexContainer gap={4}>
              <TargetCourseContent course={articulation.course} />
              <CricosCodeContent course={articulation.course} />
              <InstitutionCaption />
            </FlexContainer>
            <FlexContainer gap={4}>
              <CohortContent articulation={articulation} />
              <AdmissionCriteriaContent articulation={articulation} />
              <ViewCourseContent course={articulation.course} />
            </FlexContainer>
          </FlexContainer>
          <CreditPointsSection
            courseName={articulation.course.name}
            creditItemID={articulation.ID}
            creditType={CreditType.ARTICULATION}
            creditPoints={getTotalCreditPoints(articulation)}
          />
        </TargetArticulationContainer>
      ))}
    </TargetArticulationsContainer>
  );
}
